import axios from 'commonjs/axios'

const baseURL = window.server

axios.defaults.baseURL = baseURL;
axios.defaults.headers = {
    accept: 'application/json',
    'Content-Type': 'application/json'
};

axios.interceptors.request.use(function (config) {

    if (config.url.indexOf(baseURL) === -1) {
        return config;
    }

    config.headers = {
        ...config.headers,
        'X-Api-Version': '0.0.1'
    }

    return config;
});

export default axios;

